var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"medium-anchor",class:_vm.editorClass,attrs:{"translate":"no"}},[_c('div',{ref:"editor",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }